import React from "react";
import { FaPhone } from "react-icons/fa";
import "./Section9.css";

function HomeSection9() {
  return (
    <>
      {/* Contact Section */}
      <section className="home-contact-section text-center my-5">
        <h2 className="home-contact-heading">Contact for orders</h2>
        <div className="home-contact-info">
          For orders and inquiries, please reach out to us at:
          <br />
          <div className="home-contact-right">
            <a href="tel:+9814067069" className="home-contact-link">
              <FaPhone className="call-icon" style={{ fontSize: "1.4rem" }} />
              +91 98140 67069
            </a>
            <a
              href="mailto:shaganarts@gmail.com"
              className="home-contact-email"
            >
              <i className="fas fa-envelope" style={{ color: "white" }}></i>
              <span style={{ paddingLeft: "5px" }}>shaganarts@gmail.com</span>
            </a>
          </div>
        </div>
      </section>
    </>
  );
}

export default HomeSection9;
